var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSus1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.8736 59.835H63.1797",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_853_3799",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H80V80H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_853_3799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5362 59.8357H63.1822L56.3395 48.1527L53.957 49.5282C53.4008 49.8493 52.7362 49.3301 52.9134 48.7126L56.1464 37.4509C56.3325 36.8026 56.9983 36.4182 57.6527 36.5812L69.0222 39.4124C69.6455 39.5676 69.763 40.4026 69.2066 40.7238L66.7711 42.1299L78.8297 62.847L73.6137 71.8809H50.5361C49.1527 71.8809 48.0312 70.7595 48.0312 69.376L48.0314 62.3404C48.0316 60.9571 49.1528 59.8357 50.5362 59.8357Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7969 66.7988L16.8203 59.8354",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1323 41.9436L22.2253 45.4618C23.4233 46.1533 23.8336 47.6852 23.142 48.8832L16.8191 59.8347L30.2978 59.8349V57.0838C30.2978 56.4414 31.0797 56.1257 31.5258 56.5878L39.6625 65.0185C40.1308 65.5036 40.1308 66.2727 39.6625 66.7578L31.5259 75.1885C31.0798 75.6508 30.2978 75.335 30.2978 74.6925V71.8802L6.3875 71.8803L1.17188 62.8463L12.7108 42.8605C13.4023 41.6624 14.9344 41.2519 16.1323 41.9436Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0859 12.633L40.062 19.6494",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8754 25.33L34.8442 4.59191H45.2758L56.8145 24.578C57.5062 25.776 57.0958 27.3078 55.8976 27.9996L49.8045 31.5172C48.6065 32.2088 47.0747 31.7983 46.3831 30.6002L40.0601 19.6486L33.307 31.3525L35.6895 32.7283C36.2459 33.0494 36.1284 33.8846 35.5051 34.0397L24.1356 36.8708C23.4812 37.0338 22.8153 36.6494 22.6292 36.0011L19.3964 24.7394C19.2192 24.1221 19.8837 23.6027 20.44 23.9238L22.8754 25.33Z",
    stroke: "#011337",
    strokeWidth: 1.76,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSus1);
export default __webpack_public_path__ + "static/media/sus1.42b50eed1639d481a4d059904ed9dc0a.svg";
export { ForwardRef as ReactComponent };